import React, { useEffect, useRef, useState } from 'react';
import { useQuery } from 'react-query';
import { ApiHttpService } from 'cms/utils/http/api';
import { PostHttpService } from 'cms/utils/http/post_http_service';

export default function PostPhotoGalleryController(id) {

  const [photoGalleries, setPhotoGalleries] = useState(null);
  const [addModalIsOpen, setAddModalIsOpen] = useState(false);

  const { isLoading, data, refetch } = useQuery(['postPhotoGalleries', id], () =>
    PostHttpService.loadPostPhotoGalleries(id),
    {
      onSuccess: (data) => {
        if (data.results) {
          setPhotoGalleries(data.results)
        }
      },
    }
  );

  const closeModal = () => {
    setAddModalIsOpen(false)
  }

  const savePostPhotoGallery = (url)=>{
    PostHttpService.savePostPhotoGallery(id, url).then(response=>{
        refetch();
    });
  }

  return {
    isLoading,
    photoGalleries,
    setPhotoGalleries,
    closeModal,
    addModalIsOpen,
    setAddModalIsOpen,
    refetch,
    savePostPhotoGallery

  };;
}
